'use strict';

var _setup = require('./setup.js');

var loaderCheckActive = true;
var firePageloadEvent = function firePageloadEvent() {
  return _setup.s.$window.trigger('nx.page.loaded');
};

var pageIsLoaded = function pageIsLoaded() {
  TweenMax.to(window, 0, { scrollTo: 0 });

  setTimeout(firePageloadEvent, 50);

  TweenMax.to('#nx-loadscreen-meter', 0.2, { y: _setup._s.headerHeight, delay: 0.2, ease: Expo.easeOut });
  TweenMax.to('.nx-loadscreen--icon', 0.3, { autoAlpha: 0 });

  TweenMax.fromTo(_setup.s.$header, 0.35, { y: '-100%' }, { y: '0%', onComplete: function onComplete() {
      _setup.s.$header.removeAttr('style');
    } });

  TweenMax.fromTo(_setup.s.$main, 0.35, { y: _setup._s.headerHeight }, { y: 0, onComplete: function onComplete() {
      _setup.s.$main.css({ transform: 'none' });
      _setup.s.$body.addClass('is-page-loaded');
    } });

  TweenMax.to(_setup.s.$loadscreen, 0.2, { autoAlpha: 0, delay: 0.25 });

  if (loaderCheckActive) {
    window.clearInterval(checkLoader);
  }
};

var checkLoader = window.setTimeout(function () {
  if (!window.magtheme.paceFinished) {
    loaderCheckActive = false;
    pageIsLoaded();
  }
}, 7000);

//just in case
if (!window.magtheme.paceFinished) {

  if (window.Pace && window.paceOptions) {
    Pace.on('done', pageIsLoaded);
  } else {
    _setup.s.$window.on('load', pageIsLoaded);
  }
} else {
  _setup.s.$window.on('load', pageIsLoaded);
}


//////////////////
// WEBPACK FOOTER
// ./_js/page-loader.js
// module id = 10
// module chunks = 0